import { createModalStore } from '@/shared/lib/modal';
import { Plan, Price } from '@/shared/types/Billing';

type DowngradeConfirmationModalProps = {
  currentPlan?: Plan;
  featuresToLose?: string[];
  targetPlan?: Plan;
  targetPrice?: Price;
};

const initialState: DowngradeConfirmationModalProps = {
  currentPlan: undefined,
  featuresToLose: undefined,
  targetPlan: undefined,
  targetPrice: undefined,
};

export const useDowngradeConfirmationModalStore = createModalStore<DowngradeConfirmationModalProps>(initialState, false);
